import styled from "styled-components";

const StyledLoader = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  z-index: 1;
`;

const LoaderContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

const LoaderLogo = styled.div`
  width: 100%
  height: 100%;
  position: absolute;
  z-index: 2;
  top: 50%; 
  right: 50%;
`;

export { StyledLoader, LoaderContainer, LoaderLogo };
